import { render, staticRenderFns } from "./BlockedProducts.vue?vue&type=template&id=616dd64c&scoped=true"
import script from "./BlockedProducts.vue?vue&type=script&lang=js"
export * from "./BlockedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616dd64c",
  null
  
)

export default component.exports